var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 331.411,
    height: 213.752,
    viewBox: "0 0 331.411 213.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M43.712 73.282c6.817-23.215 28.266-40.17 53.687-40.17 4.704 0 9.27.587 13.635 1.68C123.368 13.97 146.05 0 172.005 0c35.25 0 64.472 25.756 69.907 59.473.305-.005.608-.023.916-.023 28.004 0 51.203 20.57 55.315 47.42 18.85 2.974 33.267 19.288 33.267 38.975 0 20.8-16.092 37.825-36.502 39.34l.043.123H186c-7.7 5.653-17.203 9-27.488 9-6.08 0-11.88-1.18-17.203-3.3-8.334 7.894-19.58 12.745-31.965 12.745-12.72 0-24.245-5.113-32.64-13.39-5.065 1.364-10.386 2.106-15.883 2.106C27.23 192.47 0 165.24 0 131.645c0-27.648 18.454-50.97 43.712-58.364z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud10);
export default __webpack_public_path__ + "static/media/cloud-10.0b92b4b5cd7794250f6d051c9b266d22.svg";
export { ForwardRef as ReactComponent };